module.exports = __webpack_public_path__ + "img/stickers-bulletin-paie-x1.0c375f1f.jpg";